import { STATUS_RENCANA_AKSI } from '@/consts/consts'

export { STATUS_RENCANA_AKSI }

// status yang membuat form penilaian pelaksanaan menjadi readonly
export const STATUS_READONLY = [STATUS_RENCANA_AKSI.SIAP_DINILAI]

export function isReadonlyStatus(status) {
  return STATUS_READONLY.includes(status)
}
